/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * All-time outcome counts for resolved feedback on a skill.
 */
export type SkillFeedbackCounts = {
  didNotHelp: number;
  harmful: number;
  helped: number;
  misleading: number;
  partiallyHelped: number;
  total: number;
};

/** @internal */
export const SkillFeedbackCounts$inboundSchema: z.ZodMiniType<
  SkillFeedbackCounts,
  unknown
> = z.pipe(
  z.object({
    did_not_help: z.int(),
    harmful: z.int(),
    helped: z.int(),
    misleading: z.int(),
    partially_helped: z.int(),
    total: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "did_not_help": "didNotHelp",
      "partially_helped": "partiallyHelped",
    });
  }),
);

export function skillFeedbackCountsFromJSON(
  jsonString: string,
): SafeParseResult<SkillFeedbackCounts, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillFeedbackCounts$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillFeedbackCounts' from JSON`,
  );
}
